var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.852,
    height: 16.004,
    viewBox: "0 0 16.852 16.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-4.989 -6.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8501",
    "data-name": "Caminho 8501",
    d: "M18.472,15.267a3.369,3.369,0,0,0-2.8,1.5L11.539,14.7a3.369,3.369,0,0,0,.194-1.116,3.319,3.319,0,0,0-.126-.9l3.946-1.63A3.369,3.369,0,1,0,15.1,9.371a3.319,3.319,0,0,0,.126.9L11.282,11.9a3.369,3.369,0,1,0-.118,3.542L15.3,17.508a3.369,3.369,0,1,0,3.176-2.241Zm0-8.424a2.527,2.527,0,1,1-2.527,2.527,2.527,2.527,0,0,1,2.527-2.527ZM8.363,16.11a2.527,2.527,0,1,1,2.527-2.527A2.527,2.527,0,0,1,8.363,16.11Zm10.108,5.054A2.527,2.527,0,1,1,21,18.637,2.527,2.527,0,0,1,18.472,21.164Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e22d82267a2f6df0b05d5783cc41c0db.svg";
export { ForwardRef as ReactComponent };